var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 5.66699C12.7706 5.66699 13.666 4.77156 13.666 3.66699C13.666 2.56242 12.7706 1.66699 11.666 1.66699C10.5614 1.66699 9.66602 2.56242 9.66602 3.66699C9.66602 4.77156 10.5614 5.66699 11.666 5.66699Z",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 13.667C12.7706 13.667 13.666 12.7716 13.666 11.667C13.666 10.5624 12.7706 9.66699 11.666 9.66699C10.5614 9.66699 9.66602 10.5624 9.66602 11.667C9.66602 12.7716 10.5614 13.667 11.666 13.667Z",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.666 21.667C12.7706 21.667 13.666 20.7716 13.666 19.667C13.666 18.5624 12.7706 17.667 11.666 17.667C10.5614 17.667 9.66602 18.5624 9.66602 19.667C9.66602 20.7716 10.5614 21.667 11.666 21.667Z",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 5.66699C4.77059 5.66699 5.66602 4.77156 5.66602 3.66699C5.66602 2.56242 4.77059 1.66699 3.66602 1.66699C2.56145 1.66699 1.66602 2.56242 1.66602 3.66699C1.66602 4.77156 2.56145 5.66699 3.66602 5.66699Z",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 13.667C4.77059 13.667 5.66602 12.7716 5.66602 11.667C5.66602 10.5624 4.77059 9.66699 3.66602 9.66699C2.56145 9.66699 1.66602 10.5624 1.66602 11.667C1.66602 12.7716 2.56145 13.667 3.66602 13.667Z",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.666 5.66699C20.7706 5.66699 21.666 4.77156 21.666 3.66699C21.666 2.56242 20.7706 1.66699 19.666 1.66699C18.5614 1.66699 17.666 2.56242 17.666 3.66699C17.666 4.77156 18.5614 5.66699 19.666 5.66699Z",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.666 13.667C20.7706 13.667 21.666 12.7716 21.666 11.667C21.666 10.5624 20.7706 9.66699 19.666 9.66699C18.5614 9.66699 17.666 10.5624 17.666 11.667C17.666 12.7716 18.5614 13.667 19.666 13.667Z",
    stroke: "#282829",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.0ac463cdfcc54d71edcf26b23175bbfa.svg";
export { ForwardRef as ReactComponent };